import ReactDOM from 'react-dom/client'
import './index.scss'
import './api/config'
import reportWebVitals from './reportWebVitals'
import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { App } from 'App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
library.add(far, fas)

root.render(<App />)

reportWebVitals()
